import { Spinner } from "@blueprintjs/core"

const ScreenshotOverlay = ({ isVisible }: { isVisible: boolean }) => {
  if (!isVisible) return null

  return (
    <div className="absolute left-1/2 top-1/2 z-[1000] flex -translate-x-1/2 -translate-y-1/2 flex-col items-center rounded-lg p-4">
      <Spinner size={25} />
    </div>
  )
}

export default ScreenshotOverlay
